import { NavLink } from 'react-router-dom';

const withActiveClassname = ({className, activeClass}) => ({isActive}) => [className, isActive ? activeClass : null].filter(Boolean).join(' ')

const RouterLink = ({to, href, children, className, activeClass, ...props}) => {
  if (to) return (
    <NavLink
      to={to}
      className={withActiveClassname({className, activeClass})}
      {...props}
    >
      {children}
    </NavLink>
  )

  return (
    <a
      href={href}
      className={className}
      {...props}
    >
      {children}
    </a>
  )
}

export default RouterLink;
